// partidaService.js - Manejo de partidas (usa cookies automáticamente)
import apiClient from './apiClient.js'

export const partidaService = {

  // Obtener la partida actual de la sesión (sin parámetros, usa cookie)
  async getSessionPartida() {
    try {
      console.log('🔍 [PartidaService] Obteniendo partida actual de la sesión')

      const response = await apiClient.get('/partidas/session/current')

      if (response.data && response.data.length > 0) {
        const partida = response.data[0] // Tomar la primera partida
        console.log('✅ [PartidaService] Partida actual encontrada:', partida.partidaCode)
        return { success: true, data: partida }
      }

      console.log('📝 [PartidaService] No hay partida activa para esta sesión')
      return { success: true, data: null }
    } catch (error) {
      console.error('❌ [PartidaService] Error obteniendo partida actual:', error)
      return { success: false, error: error.message || 'Error obteniendo partida actual' }
    }
  },

  // Crear nueva partida (usa cookie para sessionId automáticamente)
  async createPartida(gameId, gameCode) {
    try {
      console.log('🏗️ [PartidaService] Creando nueva partida')

      const response = await apiClient.post('/partidas', {
        gameId,
        gameCode
      })

      if (response.data) {
        console.log('✅ [PartidaService] Partida creada exitosamente:', response.data.data.partidaCode)
        return {
          success: true,
          data: response.data.data
        }
      }

      return {
        success: false,
        error: 'No se pudo crear la partida'
      }
    } catch (error) {
      console.error('❌ [PartidaService] Error creando partida:', error)
      return {
        success: false,
        error: error.response?.data?.error || 'Error creando partida'
      }
    }
  },

  // Obtener partida por código
  async getPartida(partidaCode) {
    try {
      console.log('🔍 [PartidaService] Obteniendo partida:', partidaCode)

      const response = await apiClient.get(`/partidas/${partidaCode}`)

      if (response.data) {
        console.log('✅ [PartidaService] Partida encontrada:', response.data.data.partidaCode)
        return {
          success: true,
          data: response.data.data
        }
      }

      return {
        success: false,
        error: 'Partida no encontrada'
      }
    } catch (error) {
      console.error('❌ [PartidaService] Error obteniendo partida:', error)
      return {
        success: false,
        error: error.response?.data?.error || 'Error obteniendo partida'
      }
    }
  },

  // Actualizar estado de la partida
  async updatePartidaState(partidaCode, currentSceneId, currentPuzzleState) {
    try {
      console.log('🔄 [PartidaService] Actualizando estado de partida:', partidaCode)

      const response = await apiClient.put(`/partidas/${partidaCode}/state`, {
        currentSceneId,
        currentPuzzleState
      })

      console.log('✅ [PartidaService] Estado de partida actualizado correctamente')
      return {
        success: true,
        data: response.data.data || response.data
      }
    } catch (error) {
      console.error('❌ [PartidaService] Error actualizando estado de partida:', error)
      return {
        success: false,
        error: error.response?.data?.error || 'Error actualizando estado de partida'
      }
    }
  },

  // Actualizar status de la partida
  async updatePartidaStatus(partidaCode, status) {
    try {
      console.log('🔄 [PartidaService] Actualizando status de partida:', partidaCode)

      const response = await apiClient.put(`/partidas/${partidaCode}/status`, {
        status
      })

      console.log('✅ [PartidaService] Status de partida actualizado correctamente')
      return {
        success: true,
        data: response.data.data || response.data
      }
    } catch (error) {
      console.error('❌ [PartidaService] Error actualizando status de partida:', error)
      return {
        success: false,
        error: error.response?.data?.error || 'Error actualizando status de partida'
      }
    }
  },

  async updatePartidaSessionId(partidaCode, sessionId) {
    try {
      console.log('🔄 [PartidaService] Actualizando sessionId de partida:', partidaCode)

      const response = await apiClient.post(`/partidas/${partidaCode}/update-session-id`, {
        sessionId
      })

      console.log('✅ [PartidaService] Session ID de partida actualizado correctamente')
      return {
        success: true,
        data: response.data.data || response.data
      }
    } catch (error) {
      console.error('❌ [PartidaService] Error actualizando session ID de partida:', error)
      return {
        success: false,
        error: error.response?.data?.error || 'Error actualizando session ID de partida'
      }
    }
  },

  async setPlayersCount(partidaCode, playersCount) {
    try {
      console.log('🔄 [PartidaService] Estableciendo número de jugadores:', partidaCode)

      const response = await apiClient.put(`/partidas/${partidaCode}/players`, {
        playersCount
      })

      console.log('✅ [PartidaService] Número de jugadores establecido correctamente')
      return {
        success: true,
        data: response.data.data || response.data
      }
    } catch (error) {
      console.error('❌ [PartidaService] Error estableciendo número de jugadores:', error)
      return {
        success: false,
        error: error.response?.data?.error || 'Error estableciendo número de jugadores'
      }
    }
  },

  // Obtener progreso de la partida (desde gameState)
  async getPartidaProgress(partidaCode) {
    try {
      console.log('🔍 [PartidaService] Obteniendo progreso de partida:', partidaCode)

      // Obtener la partida completa y extraer el progreso del gameState
      const response = await apiClient.get(`/partidas/${partidaCode}`)

      if (response.data && response.data.data) {
        const partida = response.data.data
        const progress = partida.gameState?.progress || 0
        
        console.log('✅ [PartidaService] Progreso obtenido:', progress + '%')
        return {
          success: true,
          data: {
            partidaCode: partida.partidaCode,
            progress: progress,
            status: partida.status,
            currentSceneId: partida.gameState?.currentSceneId || null,
            currentPuzzleState: partida.gameState?.currentPuzzleState || null
          }
        }
      }

      return {
        success: false,
        error: 'No se pudo obtener el progreso de la partida'
      }
    } catch (error) {
      console.error('❌ [PartidaService] Error obteniendo progreso de partida:', error)
      return {
        success: false,
        error: error.response?.data?.error || 'Error obteniendo progreso de partida'
      }
    }
  },
  
  async getAllPartidas() {
    try {
      console.log('🔍 [PartidaService] Obteniendo todas las partidas')

      const response = await apiClient.get('/partidas')

      if (response.data && response.data.success) {
        console.log('✅ [PartidaService] Partidas obtenidas:', response.data.data)
        return {
          success: true,
          data: response.data.data
        }
      }

      return {
        success: false,
        error: 'No se pudieron obtener las partidas'
      }
    } catch (error) {
      console.error('❌ [PartidaService] Error obteniendo todas las partidas:', error)
      return {
        success: false,
        error: error.response?.data?.error || 'Error obteniendo todas las partidas'
      }
    }
  },

  // Establecer timestamp de inicio del puzzle actual
  async setPuzzleStartedAt(partidaCode, puzzleStartedAt = null) {
    try {
      console.log('⏰ [PartidaService] Estableciendo timestamp de inicio del puzzle:', partidaCode)

      const timestamp = puzzleStartedAt || new Date().toISOString()
      const response = await apiClient.put(`/partidas/${partidaCode}/puzzle-started`, {
        puzzleStartedAt: timestamp
      })

      console.log('✅ [PartidaService] Timestamp de puzzle establecido correctamente')
      return {
        success: true,
        data: response.data.data || response.data
      }
    } catch (error) {
      console.error('❌ [PartidaService] Error estableciendo timestamp de puzzle:', error)
      return {
        success: false,
        error: error.response?.data?.error || 'Error estableciendo timestamp de puzzle'
      }
    }
  }
}

export default partidaService
